import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const CONSUMIDOR_PREFIX = `${APP_PREFIX_PATH}/consumidor`;

const ConsumidorDashboard = lazy(() => import("./dashboard"));

export const ConsumidorViews = () => {
	return (
		<Suspense fallback={<Loading cover="content" />}>
			<Switch>
				<Route
					path={`${CONSUMIDOR_PREFIX}/dashboard`}
					component={ConsumidorDashboard}
				/>
				<Redirect
					from={`${APP_PREFIX_PATH}`}
					to={`${CONSUMIDOR_PREFIX}/dashboard`}
				/>
			</Switch>
		</Suspense>
	);
};

export default ConsumidorViews;
